import i18n from "@/langs/i18n";

export function getAll() {
  return [
    {
      value: -1,
      name: "All",
      text: `${i18n.t("option.foodStatusType.All")}`,
    },
    {
      value: 0,
      name: "Normal",
      text: `${i18n.t("option.foodStatusType.Normal")}`,
    },
    {
      value: 1,
      name: "Discontinued",
      text: `${i18n.t("option.foodStatusType.Discontinued")}`,
    },
  ];
}
